// PsyPractice: hukuki belgeler / Română.
//
// Bölüm sırası, başlık numaraları ve hukuki iddialar TÜM dillerde aynıdır; esasa
// ilişkin bir değişiklik bütün dillerde birlikte yapılır ve shared.ts'teki
// LEGAL_VERSION birlikte artar: aksi hâlde kullanıcının onayladığı sürüm ile
// okuduğu metin ayrışır. Yalnızca çeviri eklemek sürümü ARTIRMAZ.
import { LEGAL_VERSION, MERCHANT, type LegalDoc } from "./shared";

// İşletme türünün ADI dile bağlıdır, resmî bilgiler (ad, adres, vergi) değildir :
// bu yüzden shared.ts'te değil, her dilin kendi dosyasında durur.
const OWNER_TYPE = "Întreprindere individuală";

const OWNER = 'PsyPractice (denumită în continuare „Platforma” sau „Operatorul de date”)';

export const DOCS: LegalDoc[] = [
  {
    id: "terms",
    title: "Termeni de utilizare și declinarea răspunderii",
    description:
      "Natura și limitele serviciului, ce nu înlocuiește, angajamentele utilizatorului și o renunțare cuprinzătoare care plasează întreaga răspundere asupra utilizatorului.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Părțile și acceptarea",
        paras: [
          `Prezenții Termeni de utilizare se încheie între ${OWNER} și orice persoană fizică sau juridică ce accesează sau utilizează Platforma („Utilizatorul”). Prin crearea unui cont, prin autentificare sau prin utilizarea Platformei în orice mod, Utilizatorul confirmă că a citit, a înțeles și acceptă necondiționat și în întregime prezenții Termeni și se angajează să îi respecte. Cine nu acceptă acești Termeni nu trebuie să utilizeze Platforma.`,
        ],
      },
      {
        heading: "2. Natura și limitele serviciului",
        bullets: [
          "PsyPractice este un software de SIMULARE a pacienților, asistat de inteligență artificială, care le permite studenților la psihologie și clinicienilor aflați la început de carieră să își desfășoare și să își consemneze propria practică de interviu clinic într-un mediu sigur.",
          "PsyPractice nu este un serviciu de educație sau de instruire; este un instrument software care îi permite utilizatorului să își desfășoare și să își consemneze propria practică. Platforma nu oferă lecții, curriculum, examene sau documente și nu conferă niciun titlu, nicio calificare și nicio autorizație.",
          "„Pacientul” simulat nu este un client real; răspunsurile sale sunt generate de inteligența artificială, pot fi eronate, incomplete, inconsecvente sau înșelătoare și nu au nicio pretenție de acuratețe sau adevăr clinic.",
        ],
      },
      {
        heading: "2.1. Ce nu înlocuiește Platforma",
        bullets: [
          "NU este terapie sau consiliere reală și nu înlocuiește nicio sesiune desfășurată cu un client real.",
          "NU înlocuiește supervizarea clinică. Rapoartele de feedback produse de AI-ul supervizor sunt texte generate automat; ele nu reprezintă o opinie de specialitate, o evaluare oficială sau o notă.",
          "NU este un instrument de diagnostic, de screening sau de evaluare; niciun rezultat al Platformei nu poate fi folosit pentru diagnosticarea sau luarea de decizii clinice cu privire la vreo persoană reală.",
          "NU TREBUIE folosită în situații de criză sau de urgență. În caz de ideație suicidară, de risc de vătămare a propriei persoane sau a altora ori în orice altă urgență comparabilă, închideți Platforma și contactați imediat serviciile locale de urgență sau o instituție medicală competentă.",
          "NU este o sursă de competență profesională, de licență, de titlu sau de autoritate; timpul petrecut pe Platformă și rezultatele acesteia nu pot fi prezentate niciunei instituții drept dovadă de calificare.",
        ],
      },
      {
        heading: "3. Declarațiile și angajamentele Utilizatorului",
        bullets: [
          "Utilizatorul se angajează să folosească Platforma exclusiv în limite legale și etice, în scopul dezvoltării propriei practici profesionale.",
          "Utilizatorul este de acord să NU introducă date REALE ale vreunui pacient/client, informații de identificare sau date de sănătate din categorii speciale aparținând vreunei persoane; toate consecințele juridice ale unei asemenea fapte revin exclusiv Utilizatorului.",
          "Utilizatorul se angajează să nu folosească niciun rezultat obținut de pe Platformă pentru diagnosticarea, tratamentul, intervenția sau luarea de decizii clinice cu privire la vreo persoană reală.",
          "Utilizatorul este singurul responsabil pentru propria competență profesională, pentru sfera sa de autoritate și pentru respectarea reglementărilor profesionale și etice aplicabile.",
          "Securitatea contului, confidențialitatea parolei și toate activitățile desfășurate din contul Utilizatorului sunt în responsabilitatea Utilizatorului.",
          "Contul este personal; Utilizatorul se angajează să nu îl partajeze cu alte persoane și să nu utilizeze Platforma prin mijloace automatizate (boți, scripturi etc.). Utilizarea planurilor plătite este supusă unei limite de utilizare rezonabilă (în prezent 60 de ședințe pe lună calendaristică), detaliată în Contractul de vânzare la distanță.",
        ],
      },
      {
        heading: "4. Întreaga răspundere revine Utilizatorului (renunțare)",
        paras: [
          "Platforma este furnizată „CA ATARE” și „ÎN FUNCȚIE DE DISPONIBILITATE”, fără nicio garanție expresă sau implicită de orice fel (inclusiv funcționare neîntreruptă, lipsa erorilor, adecvarea la un anumit scop, acuratețe sau actualitate).",
          "Utilizatorul acceptă și se angajează că este EXCLUSIV și PERSONAL răspunzător pentru orice prejudiciu direct, indirect, incidental, special sau subsecvent (inclusiv prejudicii materiale, morale, de reputație profesională, de pierdere a datelor, de pierdere a veniturilor și prejudicii cauzate terților) care decurge din utilizarea Platformei sau din imposibilitatea de a o utiliza, din încrederea acordată rezultatelor AI sau din aplicarea acestor rezultate în orice mod.",
          "În măsura maximă permisă de legea aplicabilă, Utilizatorul RENUNȚĂ prin prezenta, irevocabil și necondiționat, de acum și în avans, la orice pretenție, acțiune în justiție și drept la despăgubire pe care le-ar putea ridica împotriva Platformei, a proprietarilor, angajaților, dezvoltatorilor, partenerilor de afaceri și furnizorilor de servicii ai acesteia, în legătură cu orice prejudiciu pe care l-ar putea suferi în cazul unui rezultat nefavorabil.",
          "Utilizatorul se angajează, de asemenea, să exonereze pe deplin Platforma (să o despăgubească) de orice pretenție, prejudiciu, sancțiune și cost (inclusiv onorariile avocaților) în cazul în care Platforma este vizată de vreun terț sau de vreo instituție din cauza culpei, neglijenței sau utilizării de către Utilizator cu încălcarea prezenților Termeni.",
        ],
      },
      {
        heading: "5. Limitarea răspunderii",
        paras: [
          "Fără a aduce atingere dispozițiilor imperative ale legii aplicabile, răspunderea juridică totală a Platformei este în orice caz limitată la suma efectiv plătită de Utilizator Platformei în cele 12 luni anterioare evenimentului care a dat naștere pretenției respective. În cazul utilizării gratuite, această sumă este zero.",
        ],
      },
      {
        heading: "6. Proprietate intelectuală, modificare și încetare",
        bullets: [
          "Toate drepturile de proprietate intelectuală asupra Platformei, a software-ului, a designului, a șabloanelor de cazuri de pacienți și a conținutului aparțin Platformei.",
          "Toate drepturile patrimoniale transferabile de proprietate intelectuală asupra oricărui conținut pe care Utilizatorul îl creează pe Platformă (inclusiv mesajele scrise în calitate de terapeut, transcrierile sesiunilor și materialele derivate din acestea) se consideră cesionate Platformei în mod exclusiv, perpetuu și fără redevențe în momentul creării conținutului respectiv; Platforma poate utiliza, reproduce și prelucra acest conținut la nivel mondial și fără restricții, în orice scop, inclusiv pentru operarea serviciului, generarea feedbackului și îmbunătățirea și dezvoltarea sistemului (inclusiv îmbunătățirea prin învățare automată). Drepturile Utilizatorului privind datele cu caracter personal conform legislației aplicabile în materie de protecția datelor (GDPR / KVKK) nu sunt afectate de această cesiune și rămân rezervate.",
          "Platforma își rezervă dreptul de a modifica, suspenda sau întrerupe prezenții Termeni și sfera serviciului în orice moment, fără notificare prealabilă.",
          "În cazul încălcării prezenților Termeni, Platforma poate suspenda sau închide contul fără notificare prealabilă.",
        ],
      },
      {
        heading: "7. Legea aplicabilă și jurisdicția",
        paras: [
          "Prezenții Termeni sunt guvernați de legile Republicii Turcia. Instanțele și birourile de executare ale Republicii Turcia au competență asupra oricărui litigiu care ar putea apărea.",
          "Pentru consumatorii cu reședința în Uniunea Europeană, protecțiile acordate de dispozițiile imperative privind protecția consumatorilor din țara lor de reședință și de drepturile lor privind protecția datelor conform GDPR rămân rezervate; această alegere a legii nu prevalează asupra acelor dispoziții imperative.",
        ],
      },
    ],
  },
  {
    id: "privacy",
    title: "Politica de confidențialitate",
    description:
      "GDPR ca standard de bază; datele prelucrate, temeiurile juridice, găzduirea în UE, transferurile internaționale (furnizorul AI) și clauza de transfer transfrontalier conform art. 9 KVKK pentru utilizatorii din Turcia.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          `Prezenta Politică de confidențialitate explică modul în care sunt prelucrate datele cu caracter personal în cadrul Platformei operate de ${OWNER}. Ca standard de bază pentru protecția datelor, politica urmează Regulamentul general privind protecția datelor al UE (GDPR / 2016/679); pentru utilizatorii aflați în Turcia se aplică suplimentar Legea turcă nr. 6698 privind protecția datelor cu caracter personal (KVKK), în special articolul 9 privind transferurile în străinătate. Nota informativă KVKK și Declarația de consimțământ explicit fac parte integrantă din această politică.`,
        ],
      },
      {
        heading: "Operatorul de date și locul găzduirii",
        bullets: [
          "Operator de date: PsyPractice. Cererile persoanelor vizate sunt tratate prin canalul de contact anunțat pe Platformă (e-mail de contact: info@psycora.com).",
          "Găzduire: Platforma și baza sa de date sunt găzduite în Uniunea Europeană, într-un centru de date din Țările de Jos (Oracle Cloud). Pentru utilizatorii aflați în UE/SEE, datele sunt prelucrate și stocate în UE.",
          "Furnizorul de găzduire acționează exclusiv ca persoană împuternicită, în baza unui Acord de prelucrare a datelor (DPA) încheiat.",
        ],
      },
      {
        heading: "Date colectate",
        bullets: [
          "Date de cont: nume, e-mail, parolă criptată (hash), informații despre abonament/plan.",
          "Date de utilizare: sesiuni create, transcrieri ale sesiunilor, cazuri de pacienți generate, rapoarte de feedback ale supervizorului.",
          "Date tehnice: înregistrări de sesiune, IP, preferința de browser/limbă, jurnale de limitare a ratei și de securitate.",
        ],
      },
      {
        heading: "Scopurile prelucrării și temeiul juridic (art. 6 GDPR)",
        bullets: [
          "Executarea unui contract (art. 6 alin. (1) lit. (b)): crearea contului, desfășurarea sesiunilor, memoria pacientului de-a lungul mai multor sesiuni, evaluarea de către supervizor, gestionarea abonamentului și a limitelor de utilizare.",
          "Interes legitim (art. 6 alin. (1) lit. (f)): securitate, prevenirea abuzurilor, îmbunătățirea sistemului și depanare.",
          "Obligație legală (art. 6 alin. (1) lit. (c)): păstrarea/raportarea impuse de legislație.",
          "Consimțământ (art. 6 alin. (1) lit. (a)): prelucrări de analiză/îmbunătățire a produsului care nu sunt strict necesare serviciului și, acolo unde este cazul, transferul în afara UE/SEE.",
        ],
      },
      {
        heading: "Transferuri internaționale",
        paras: [
          "Întrucât găzduirea se face în UE (Țările de Jos), datele utilizatorilor din UE/SEE sunt, ca regulă, prelucrate în UE, fără transfer către o țară terță la acest nivel. Totuși, pentru generarea răspunsurilor AI, conținutul sesiunilor și prompturile sunt transmise furnizorului de servicii AI (Anthropic), a cărui infrastructură de prelucrare poate fi situată în afara UE/SEE (de ex. Statele Unite).",
          "Aceste transferuri în afara UE/SEE se bazează pe garanții adecvate conform art. 44 și următoarele din GDPR, în special Clauzele contractuale standard (SCC) ale Comisiei Europene, iar cu furnizorul se încheie un acord de prelucrare a datelor (DPA). Platforma NU vinde date cu caracter personal în scopuri de marketing; datele nu sunt transmise terților decât atunci când este strict necesar pentru operarea serviciului (sub rezerva solicitărilor legale ale autorităților competente).",
        ],
      },
      {
        heading: "Pentru utilizatorii din Turcia: art. 9 KVKK (transfer în străinătate)",
        paras: [
          "Datele cu caracter personal ale utilizatorilor aflați în Turcia sunt transferate în afara Turciei deoarece găzduirea se face în Țările de Jos (UE) și pot fi transferate și către Anthropic pentru prelucrare AI. Aceste transferuri intră sub incidența art. 9 KVKK și se bazează pe garanții adecvate (contractul standard / angajamentul publicat de Autoritate) sau, acolo unde este necesar, pe consimțământul dumneavoastră explicit. Sfera, destinatarii și scopul transferului sunt detaliate în Nota informativă KVKK și în Declarația de consimțământ explicit.",
        ],
      },
      {
        heading: "Drepturile persoanei vizate (art. 15-22 GDPR)",
        bullets: [
          "Acces, rectificare, ștergere („dreptul de a fi uitat”) și restricționarea prelucrării.",
          "Portabilitatea datelor: primirea datelor pe care le-ați furnizat într-un format structurat, utilizat în mod curent și care poate fi citit automat.",
          "Opoziție: opoziția față de prelucrarea bazată pe interes legitim și față de marketingul direct.",
          "Drepturi legate de deciziile individuale automatizate/profilare.",
          "Retragerea consimțământului în orice moment pentru prelucrările bazate pe consimțământ (retragerea nu afectează legalitatea prelucrării efectuate până în acel moment).",
          "Dreptul de a depune o plângere la o autoritate de supraveghere: autoritatea competentă pentru protecția datelor din UE; Autoritatea pentru Protecția Datelor cu Caracter Personal (KVKK) din Turcia.",
        ],
      },
      {
        heading: "Păstrarea și securitatea",
        bullets: [
          "Datele sunt păstrate atât timp cât o cere scopul prelucrării și pe perioadele prevăzute de legea aplicabilă; la expirarea perioadei sunt șterse sau anonimizate.",
          "Câmpurile sensibile (de ex. parola, codurile de verificare și de resetare) sunt păstrate criptat/hash; accesul se face pe bază de permisiuni.",
          "Întrucât nicio metodă de transmitere sau de stocare nu este 100% sigură, securitatea absolută nu poate fi garantată.",
        ],
      },
      {
        heading: "Interdicția privind datele pacienților reali",
        paras: [
          "Platforma este un software de simulare; introducerea de date personale/de sănătate aparținând unor clienți reali este interzisă. Întreaga răspundere care decurge din introducerea de date de către Utilizator cu încălcarea acestei interdicții revine exclusiv Utilizatorului.",
        ],
      },
    ],
  },
  {
    id: "kvkk",
    title: "Notă informativă KVKK",
    description:
      "Operatorul de date, scopurile prelucrării, temeiul juridic, transferul și drepturile persoanei vizate conform articolului 10 din Legea nr. 6698.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Operatorul de date",
        paras: [
          `În temeiul articolului 10 din Legea turcă nr. 6698 privind protecția datelor cu caracter personal („KVKK”), datele dumneavoastră cu caracter personal sunt prelucrate de ${OWNER}, în calitate de Operator de date, în sfera descrisă mai jos.`,
        ],
      },
      {
        heading: "Date prelucrate și scopuri",
        bullets: [
          "Identitate/Contact (nume, e-mail): crearea contului, autentificare, comunicare.",
          "Tranzacții ale clientului (abonament, plan, utilizare): furnizarea serviciului, facturare, aplicarea limitelor.",
          "Securitatea tranzacțiilor (sesiune, IP, jurnale): securitate, prevenirea abuzurilor, obligație legală.",
          "Conținutul utilizatorului (transcrieri ale sesiunilor, cazuri generate): furnizarea serviciului software și generarea feedbackului.",
          "Apartenența la o cohortă instituțională (identificatorul cohortei, perioada de apartenență): atunci când utilizatorul se alătură unei cohorte organizate de o instituție, vizibilitatea pentru îndrumător și administrarea cohortei.",
        ],
      },
      {
        heading: "Temeiul juridic (art. 5)",
        bullets: [
          "Încheierea/executarea unui contract: datele necesare pentru furnizarea serviciului.",
          "Interesul legitim al operatorului de date: securitate, prevenirea fraudei, îmbunătățirea sistemului.",
          "Obligație legală: păstrarea/raportarea impuse de legislație.",
          "Consimțământ explicit: transferul în străinătate (art. 9) și prelucrările suplimentare care nu sunt strict necesare serviciului.",
        ],
      },
      {
        heading: "Transferul în străinătate (art. 9)",
        paras: [
          "Întrucât Platforma și baza sa de date sunt găzduite în Uniunea Europeană, într-un centru de date din Țările de Jos (Oracle Cloud), datele cu caracter personal ale utilizatorilor aflați în Turcia sunt transferate în afara Turciei (în UE). În plus, pentru generarea răspunsurilor AI, conținutul sesiunilor și prompturile pot fi transferate furnizorului de servicii AI (Anthropic), a cărui infrastructură de prelucrare poate fi situată în afara UE/SEE (de ex. Statele Unite).",
          "Aceste transferuri în străinătate intră sub incidența art. 9 KVKK și se bazează pe garanții adecvate, precum contractul standard / angajamentul publicat de Autoritate, sau, acolo unde este necesar, pe consimțământul dumneavoastră explicit. Cu furnizorii de găzduire și de servicii se încheie acorduri de prelucrare a datelor (DPA).",
        ],
      },
      {
        heading: "Cohorte instituționale și vizibilitatea pentru îndrumător",
        paras: [
          "Dacă vă alăturați unei cohorte deschise de o universitate, o clinică sau o instituție similară, conținutul sesiunilor dumneavoastră (transcrierile) și rapoartele de supervizare pot fi văzute de îndrumătorul acelei cohorte pe durata cohortei. Această vizibilitate acoperă doar sesiunile dumneavoastră atașate cohortei și încetează odată cu încetarea apartenenței la cohortă.",
          "Acest acces se obține printr-un ecran SEPARAT de consimțământ explicit, afișat la alăturarea la cohortă; el nu face parte din acceptarea generală a Platformei. Dacă nu vă dați acest consimțământ, nu vă puteți alătura cohortei, dar puteți continua să folosiți Platforma individual, exact ca înainte. Retragerea consimțământului încheie apartenența la cohortă și lasă neafectată utilizarea individuală.",
        ],
      },
      {
        heading: "Drepturile persoanei vizate (art. 11)",
        bullets: [
          "Să aflați dacă datele dumneavoastră cu caracter personal sunt prelucrate și, în caz afirmativ, să solicitați informații.",
          "Să aflați scopul prelucrării și dacă datele sunt folosite conform acelui scop.",
          "Să cunoașteți terții cărora le sunt transferate datele, în țară sau în străinătate.",
          "Să solicitați rectificarea prelucrării incomplete/incorecte și, dacă sunt îndeplinite condițiile, ștergerea/distrugerea.",
          "Să vă opuneți unui rezultat defavorabil dumneavoastră care decurge exclusiv din analiza automatizată.",
          "Să solicitați despăgubiri pentru prejudiciul suferit din cauza prelucrării ilegale.",
        ],
      },
      {
        heading: "Cereri",
        paras: [
          "Puteți transmite cereri privind drepturile dumneavoastră prin canalul de contact anunțat de Operatorul de date. Cererile sunt soluționate în termenele prevăzute de KVKK și de legislația sa secundară.",
        ],
      },
    ],
  },
  {
    id: "consent",
    title: "Declarație de consimțământ explicit",
    description:
      "Separată de nota informativă; consimțământ acordat liber pentru transferul în străinătate și prelucrarea AI.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Declar că am citit și am înțeles Nota informativă KVKK și că îmi dau, în mod liber, informat și explicit, consimțământul pentru prelucrarea descrisă mai jos. (În temeiul deciziei Autorității KVKK nr. 2018/90, consimțământul explicit se obține separat de obligația de a informa.)",
        ],
      },
      {
        heading: "Prelucrări pentru care se acordă consimțământul",
        bullets: [
          "Transferul datelor mele cu caracter personal în afara Turciei, precum și stocarea și prelucrarea lor acolo, deoarece Platforma este găzduită în Uniunea Europeană (Țările de Jos / Oracle Cloud) (art. 9 KVKK).",
          "Transferul și prelucrarea transcrierilor sesiunilor mele și a prompturilor la furnizorul de servicii AI (Anthropic), a cărui infrastructură de prelucrare poate fi situată în afara UE/SEE, în scopul generării răspunsurilor AI (art. 9 KVKK).",
          "Prelucrarea în scopul îmbunătățirii produsului și al analizei, care nu este strict necesară pentru furnizarea serviciului.",
          "Primirea notificărilor legate de serviciu.",
        ],
      },
      {
        heading: "Retragerea consimțământului",
        paras: [
          "Înțeleg că îmi pot retrage consimțământul explicit în orice moment; totuși, întrucât transferul în străinătate către furnizorul AI este necesar din punct de vedere tehnic pentru funcționarea serviciului, accept că retragerea acestui consimțământ poate avea ca rezultat imposibilitatea de a folosi funcțiile respective sau serviciul în ansamblu. Retragerea nu afectează legalitatea prelucrării efectuate până la data retragerii.",
        ],
      },
    ],
  },
  {
    // Counterpart of the TR "outreach" notice: see the comment there.
    id: "outreach",
    title: "Notă informativă privind comunicările de contact",
    description:
      "Pentru cadrele universitare și persoanele de contact instituționale care au primit un e-mail de prezentare instituțională: de unde provin datele, de ce sunt prelucrate, temeiul juridic și cum puteți refuza.",
    updated: "2026-08-06",
    sections: [
      {
        paras: [
          "Prezenta notă îi informează pe destinatarii e-mailurilor de prezentare instituțională trimise de PsyPractice departamentelor de psihologie ale universităților și personalului lor academic, în conformitate cu articolul 10 din Legea turcă nr. 6698 privind protecția datelor cu caracter personal (KVKK) și cu Comunicatul privind procedurile și principiile de îndeplinire a obligației de a informa. Întrucât datele dumneavoastră cu caracter personal nu au fost obținute direct de la dumneavoastră, notificarea se face cel târziu la momentul primului contact, motiv pentru care e-mailul de prezentare trimite aici.",
        ],
      },
      {
        heading: "1. Operatorul de date",
        bullets: [
          `Nume: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Adresă: ${MERCHANT.addressEn}`,
          `Administrația fiscală / nr.: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `E-mail: ${MERCHANT.email}`,
          `Web: ${MERCHANT.website}`,
        ],
      },
      {
        heading: "2. Datele prelucrate și sursa lor",
        paras: [
          "Prelucrarea se limitează la date de contact profesionale: nume, titlu academic, universitate și departament, adresa de e-mail instituțională și, acolo unde este publicat, numărul de telefon instituțional.",
          "Aceste date nu au fost colectate de la dumneavoastră, ci compilate din paginile oficiale, publicate public, ale departamentelor și facultăților universităților. Nu se prelucrează categorii speciale de date, iar adresele de e-mail private (neinstituționale) nu sunt folosite pentru contactare.",
        ],
      },
      {
        heading: "3. Scopul",
        paras: [
          "Datele dumneavoastră sunt prelucrate pentru a prezenta un instrument software construit pentru studenții la psihologie, pentru a invita departamentul dumneavoastră la o posibilă discuție despre un pilot sau o colaborare și pentru a purta corespondența aferentă. Nu sunt folosite în niciun alt scop, nu sunt vândute și nu sunt transferate terților în scopuri de marketing.",
        ],
      },
      {
        heading: "4. Temeiul juridic",
        paras: [
          "Prelucrarea se bazează pe interesele legitime ale operatorului de date conform articolului 5/2-(f) KVKK, cu condiția ca acestea să nu aducă atingere drepturilor și libertăților dumneavoastră fundamentale: contactul se face doar la o adresă instituțională, doar într-o chestiune direct legată de domeniul profesional al destinatarului și de un număr limitat de ori.",
          "Simplul fapt că datele sunt disponibile public online nu constituie, în sine, un temei juridic. Autoritatea pentru Protecția Datelor cu Caracter Personal a statuat că faptul că datele sunt publice nu le face utilizabile în orice scop și că intenția și scopul publicării trebuie evaluate separat; prin urmare, articolul 5/2-(d) nu este invocat.",
        ],
      },
      {
        heading: "5. Transferuri și păstrare",
        paras: [
          "Corespondența se desfășoară printr-un furnizor de e-mail a cărui infrastructură poate fi situată în străinătate; astfel de transferuri se fac cu garanții adecvate conform articolului 9 KVKK.",
          "Datele dumneavoastră sunt șterse odată ce scopul contactului încetează sau la cererea dumneavoastră. După o cerere de ștergere se păstrează doar o înregistrare strict limitată de tip „a nu se contacta”, exclusiv pentru a ne asigura că nu veți mai fi contactat; ea nu este folosită niciodată pentru prezentări.",
        ],
      },
      {
        heading: "6. Mesajele electronice comerciale și dreptul de refuz",
        paras: [
          "Mesajele promoționale intră sub incidența Legii nr. 6563 privind reglementarea comerțului electronic. Le puteți refuza fără a indica vreun motiv; refuzurile sunt procesate în cel mult trei zile lucrătoare, după care nu se mai trimite niciun mesaj promoțional. Este suficient să răspundeți la e-mailul primit sau să scrieți la " + MERCHANT.email + ".",
        ],
      },
      {
        heading: "7. Drepturile dumneavoastră",
        paras: [
          "În temeiul articolului 11 KVKK aveți dreptul să aflați dacă datele dumneavoastră cu caracter personal sunt prelucrate, să solicitați informații despre acestea, să aflați scopul prelucrării și dacă sunt folosite conform acestuia, să cunoașteți terții cărora le sunt transferate în Turcia sau în străinătate, să solicitați corectarea datelor incomplete sau inexacte, să solicitați ștergerea sau distrugerea lor, să solicitați ca aceste operațiuni să fie notificate terților, să vă opuneți unui rezultat defavorabil dumneavoastră produs exclusiv prin analiză automatizată și să solicitați despăgubiri pentru prejudiciul suferit.",
          `Cererile pot fi trimise la ${MERCHANT.email} și primesc răspuns în cel mult treizeci de zile. Vă păstrați, de asemenea, dreptul de a depune o plângere la Autoritatea pentru Protecția Datelor cu Caracter Personal.`,
        ],
      },
    ],
  },
  {
    id: "cookies",
    title: "Politica privind cookie-urile",
    description: "Tipurile de cookie-uri folosite, scopurile lor și gestionarea preferințelor.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Platforma folosește cookie-uri și tehnologii similare de stocare locală (localStorage) pentru a vă menține sesiunea și a vă reține preferințele.",
        ],
      },
      {
        heading: "Tehnologii folosite",
        bullets: [
          "Strict necesare: tokenul de sesiune/autentificare, securitate. Serviciul nu funcționează fără acestea.",
          "Funcționale: preferința de limbă/localizare (NEXT_LOCALE), preferințele de interfață (de ex. tema).",
          "Performanță/securitate: jurnale tehnice pentru limitarea ratei și detectarea abuzurilor.",
        ],
      },
      {
        heading: "Gestionarea preferințelor",
        paras: [
          "Puteți șterge sau bloca cookie-urile din browser; totuși, blocarea cookie-urilor strict necesare va împiedica autentificarea și funcționalitatea de bază. În conformitate cu principiile GDPR / ePrivacy și cu Ghidul KVKK privind cookie-urile, cookie-urile neesențiale sunt folosite doar pe baza preferinței/consimțământului dumneavoastră explicit.",
        ],
      },
    ],
  },
  {
    id: "about",
    title: "Despre noi",
    description:
      "Scopul PsyPractice, serviciul oferit și datele de contact ale comerciantului (vânzătorului).",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "PsyPractice este o platformă de simulare a pacienților și de abilități clinice, asistată de AI, construită pentru studenții la psihologie și pentru clinicienii proaspăt absolvenți, aflați la început de carieră. Utilizatorii desfășoară sesiuni de terapie în scris; la finalul fiecărei sesiuni, un AI supervizor evaluează conversația și produce un raport de feedback pentru dezvoltare. AI-ul pacient duce relația terapeutică mai departe de la o sesiune la alta, prin memorie între sesiuni.",
        ],
      },
      {
        heading: "Misiunea noastră",
        paras: [
          "Scopul nostru este să le oferim viitorilor profesioniști din sănătatea mintală un mediu sigur și repetabil în care să exerseze abilitățile de interviu clinic fără niciun risc de a vătăma clienți reali. PsyPractice nu este un serviciu de educație sau de instruire; este un instrument software care îi permite utilizatorului să își desfășoare și să își consemneze propria practică. Nu este terapie sau consiliere reală, nu înlocuiește supervizarea clinică, nu este un instrument de diagnostic sau de evaluare și nu trebuie folosit în situații de criză sau de urgență.",
        ],
      },
      {
        heading: "Ce oferim",
        bullets: [
          "Simulare de sesiuni de terapie în scris cu profiluri diverse de pacienți, sintetizate din literatura clinică.",
          "Rapoarte automate de evaluare de la supervizor după fiecare sesiune.",
          "Un model de „pacient viu”, cu memorie între sesiuni, care dezvoltă relația terapeutică în timp.",
          "Generarea de pacienți personalizați, care le permite studenților să își creeze propriile cazuri AI.",
          "Indicatori de progres care urmăresc dezvoltarea microabilităților.",
        ],
      },
      {
        heading: "Informații despre vânzător / afacere",
        bullets: [
          `Denumire comercială: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Adresă: ${MERCHANT.addressEn}`,
          `Administrația fiscală / nr.: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `E-mail: ${MERCHANT.email}`,
          `Web: ${MERCHANT.website}`,
        ],
      },
    ],
  },
  {
    id: "distance-sales",
    title: "Contract de vânzare la distanță",
    description:
      "Vânzătorul, cumpărătorul, serviciul, prețul, plata, executarea și condițiile dreptului de retragere conform Legii turce nr. 6502 și Regulamentului privind contractele la distanță.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Părțile",
        bullets: [
          `VÂNZĂTOR: ${MERCHANT.legalName} (${OWNER_TYPE}). Adresă: ${MERCHANT.addressEn}. Administrația fiscală/nr.: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}. E-mail: ${MERCHANT.email}.`,
          "CUMPĂRĂTOR: persoana fizică sau juridică ce își creează un cont pe Platformă și achiziționează un abonament plătit („Cumpărătorul”).",
        ],
      },
      {
        heading: "2. Obiectul contractului",
        paras: [
          "Obiectul prezentului Contract îl constituie stabilirea drepturilor și obligațiilor părților, în conformitate cu Legea turcă nr. 6502 privind protecția consumatorilor și cu Regulamentul privind contractele la distanță, cu privire la vânzarea și executarea abonamentului la serviciul digital achiziționat electronic de Cumpărător prin intermediul Platformei, ale cărui caracteristici și preț de vânzare sunt indicate mai jos.",
        ],
      },
      {
        heading: "3. Natura serviciului și prețul",
        bullets: [
          "Serviciul vândut constă în funcțiile de simulare a pacienților asistată de AI, oferite în cadrul unui plan de abonament plătit al software-ului PsyPractice (un serviciu digital / drept de utilizare a software-ului).",
          "PsyPractice nu este un serviciu de educație sau de instruire; este un instrument software care îi permite utilizatorului să își desfășoare și să își consemneze propria practică. Taxa de abonament reprezintă contravaloarea accesului la acel software; nu este o taxă pentru lecții, curriculum, examene, consultanță sau vreun document.",
          "Conținutul planului, durata (lunar, o perioadă de 4 luni sau anual) și prețul în vigoare sunt afișate clar pe pagina de prețuri/plată a Platformei în momentul achiziției; suma totală cu taxele incluse este comunicată Cumpărătorului înainte de plată.",
          "Prețurile se aplică în moneda afișată pe Platformă; dacă nu este anulat, abonamentul se reînnoiește automat la același preț la sfârșitul duratei selectate.",
          "La planurile oferite ca „ședințe nelimitate”, utilizarea este supusă unei limite de utilizare rezonabilă (în prezent 60 de ședințe pe lună calendaristică). După atingerea limitei, se pot începe din nou ședințe noi începând cu prima zi a lunii calendaristice următoare; aceasta nu dă dreptul la reducerea prețului sau la rambursare. Limita are scopul de a împiedica partajarea conturilor și utilizarea automatizată, iar Vânzătorul nu o modifică în defavoarea Cumpărătorului pe durata unei perioade de abonament plătite.",
        ],
      },
      {
        heading: "4. Plata",
        paras: [
          "Plățile sunt încasate în siguranță cu cardul de credit/debit prin instituția de plată autorizată iyzico. Datele cardului nu sunt stocate de Vânzător; plata este procesată prin sistemele securizate ale iyzico. Pentru plățile recurente (abonament), suma este debitată automat, la fiecare perioadă de reînnoire, de pe cardul aprobat de Cumpărător.",
        ],
      },
      {
        heading: "5. Executarea și livrarea",
        paras: [
          "Serviciul este digital și nu implică nicio livrare fizică. La confirmarea plății, funcțiile abonamentului devin imediat disponibile în contul Cumpărătorului. Executarea are loc electronic, prin asigurarea accesului neîntrerupt pe toată durata abonamentului.",
        ],
      },
      {
        heading: "6. Dreptul de retragere și excepția de la acesta",
        bullets: [
          "În temeiul articolului 15/1-(ğ) din Regulamentul privind contractele la distanță, dreptul de retragere nu poate fi exercitat pentru bunurile/serviciile necorporale (digitale) executate instantaneu în format electronic, atunci când executarea a început cu acordul Cumpărătorului.",
          "Cumpărătorul ia la cunoștință în momentul achiziției că serviciul va fi executat imediat și că, prin urmare, nu există un drept de retragere. Cumpărătorul poate anula abonamentul în orice moment pentru a opri reînnoirea; anularea produce efecte la sfârșitul perioadei plătite curente.",
          "Pentru condițiile detaliate de rambursare, consultați „Condițiile de livrare și rambursare”.",
        ],
      },
      {
        heading: "7. Litigii și intrarea în vigoare",
        paras: [
          "În caz de litigiu, Cumpărătorul se poate adresa Comitetului de arbitraj pentru consumatori sau Instanțelor pentru consumatori de la locul său de reședință, în limitele valorice anunțate de Ministerul Comerțului. Prezentul Contract se încheie și intră în vigoare prin aprobarea Cumpărătorului în format electronic.",
        ],
      },
    ],
  },
  {
    id: "delivery-refund",
    title: "Condiții de livrare și rambursare",
    description:
      "Livrarea serviciului digital, anularea abonamentului, excepția de la dreptul de retragere și condițiile de rambursare.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Livrarea (serviciu digital)",
        bullets: [
          "PsyPractice este un serviciu integral digital; nu există expediere fizică de produse sau livrare prin curier.",
          "În momentul confirmării plății, funcțiile abonamentului se activează automat și instantaneu în contul Cumpărătorului; nu există un termen de livrare separat și nici o taxă de livrare.",
          "Serviciul este accesat prin browserul web al oricărui dispozitiv conectat la internet.",
        ],
      },
      {
        heading: "Anularea abonamentului",
        bullets: [
          "Cumpărătorul poate anula abonamentul în orice moment din setările contului. Anularea produce efecte la sfârșitul perioadei plătite curente și oprește următoarea reînnoire automată.",
          "După anulare, accesul la serviciu continuă pentru restul perioadei plătite.",
        ],
      },
      {
        heading: "Dreptul de retragere și rambursarea",
        bullets: [
          "Întrucât serviciul este un serviciu digital executat imediat cu acordul Cumpărătorului, ca regulă nu se naște niciun drept de retragere și, prin urmare, niciun drept de rambursare, în temeiul articolului 15/1-(ğ) din Regulamentul privind contractele la distanță.",
          "În cazuri de deficiență evidentă, precum o debitare eronată/dublă, imposibilitatea completă de a accesa serviciul din motive tehnice sau situații similare, Cumpărătorul poate solicita o rambursare contactând Vânzătorul într-un termen rezonabil de la data plății.",
          `Cererile de rambursare se trimit la ${MERCHANT.email}; rambursările aprobate sunt returnate pe cardul folosit la plată, prin infrastructura iyzico, ca regulă în termen de 14 zile. Termenul de rambursare poate varia în funcție de timpul de procesare al băncii.`,
        ],
      },
      {
        heading: "Contact",
        paras: [
          `Pentru toate chestiunile legate de livrare, anulare și rambursare: ${MERCHANT.email}${MERCHANT.phone ? " · " + MERCHANT.phone : ""}.`,
        ],
      },
    ],
  },
];
